<!-- HEADER -->
<app-header color="transparent"></app-header>

<!-- CONTENT -->
<ion-content class="padded">
  <section class="featured-item">
    <ion-row>
      <ion-col>
        <div class="img-wrapper">
          <app-img-format
            [src]="heroImage"
            alt="Error Hero"
            [aspectRatio]="'16:9'"
            [disableLazyLoad]="true"></app-img-format>
        </div>
        <ion-card>
          <ion-card-content>
            <ion-text>
              <h1>404</h1>
              <h2>OOPS, WHAT IS THIS?</h2>
              <p class="intro-paragraph">
                The page you are looking for cannot be found.
              </p>
            </ion-text>

            <p>
              <app-button
                type="secondary"
                [icon]="{ name: 'arrow-right', position: 'right' }"
                (click)="pageLink('/')"
              >
                Home
              </app-button>
            </p>

            <p>
              <app-button
                type="secondary"
                [icon]="{ name: 'arrow-right', position: 'right' }"
                (click)="pageLink('/shops')"
              >
                Shop Listing
              </app-button>
            </p>

            <p *ngIf="environmentName != 'tablebay'">
              <app-button
                type="secondary"
                [icon]="{ name: 'arrow-right', position: 'right' }"
                (click)="pageLink('/movies')"
              >
                Movies
              </app-button>
            </p>

            <p *ngIf="environmentName == 'tablebay'">
              <app-button
                type="secondary"
                [icon]="{ name: 'arrow-right', position: 'right' }"
                (click)="pageLink('/contact')"
              >
                Contact Us
              </app-button>
            </p>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </section>

  <!-- FOOTER -->
  <app-footer></app-footer>
</ion-content>